export enum LocationProjection {
  dataTable = 'dataTable',
  select = 'select',
  form = 'form',
}
